import gql from 'graphql-tag';

export const PARCEL_PROFILE_FRAGMENT = gql`
    fragment ParcelProfile on ParcelProfile {
        id
        name
        dimension {
            width
            height
            length
            unit
        }
        weight
        maxWeight
        massUnit
        channels {
          id
          code
        }
    }
`;

export const DEFAULT_FULFILLMENT_SETTINGS_FRAGMENT = gql`
    fragment DefaultFulfillmentSettingsResult on DefaultFulfillmentSettingsResult {
        parcelProfile {
            ...ParcelProfile
        }
        shippingServiceType
    }
    ${PARCEL_PROFILE_FRAGMENT}
`;

export const ESTIMATE_FULFILLMENT_WEIGHT_AND_COST_FRAGMENT = gql`
    fragment EstimateFulfillmentWeightAndCostResult on EstimateFulfillmentWeightAndCostResult {
        weight
        massUnit
        price
        rateId
    }
`;